export default __webpack_public_path__ + "static/media/Anurag_Singh_Tomar_Resume.785d3549.pdf";